import React, { useContext } from "react";
import Day from "./Day";
import { getNextDays } from "../util";
import GlobalContext from "../context/GlobalContext";

export default function Month({ month, startDate }) {
  const { tipoFiltro, dtInicial, dtFinal } =
    useContext(GlobalContext);

  let days = [];

  if (tipoFiltro === 1) {
    days = getNextDays(startDate, 7);
  } else if (tipoFiltro === 2) {
    days = getNextDays(startDate, 14);
  } else if (tipoFiltro === 3) {
    days = getNextDays(startDate, 30);
  } else if (tipoFiltro === 4 && dtInicial && dtFinal) {
    days = getNextDays(dtInicial, null, dtFinal);
  }

  return (
    <div className="flex-1 grid grid-cols-7" style={{ gridAutoRows: "min-content" }}>
      {tipoFiltro === 0
        ? month.map((row, i) => (
            <React.Fragment key={i}>
              {row.map((day, idx) => (
                <Day day={day} key={idx} rowIdx={i} />
              ))}
            </React.Fragment>
          ))
        : days.map((day, idx) => (
            <Day day={day} key={idx} rowIdx={Math.floor(idx / 7)} />
          ))}
    </div>
  );
}
